export interface TatActionTypes {
  type: TatActions;
  payload?: any;
}

export enum TatActions {
  CREATE_TAT = "CREATE_TAT",
  GET_TAT_LIST = "GET_TAT_LIST",
  SET_TAT_LIST = "SET_TAT_LIST",
  SET_TAT_LIST_PAGE_COUNT = "SET_TAT_LIST_PAGE_COUNT",
  GET_TAT_DATA_BY_ID = "GET_TAT_DATA_BY_ID",
  SET_TAT_DATA_BY_ID = "SET_TAT_DATA_BY_ID",
  EDIT_TAT_DATA_BY_ID = "EDIT_TAT_DATA_BY_ID",
}
